import React, { Component } from "react";
import { Container, Row, Col } from "shards-react";
import { Store } from "./flux";
import classNames from "classnames";

import MainNavbar from "./components/Layout/Common/MainNavbar/MainNavbar";
import MainSidebar from "./components/Layout/Common/MainSidebar/MainSidebar";

import Login from "./components/Login/Login";
import OAuthCallback from "./components/Login/OAuthCallback";

import Building from "./components/OtherInfo/Building/building";
import Location from "./components/OtherInfo/Location/location";
import Room from "./components/OtherInfo/Room/room";
import Title from "./components/OtherInfo/Title/title";
import Position from "./components/OtherInfo/Position/position";
import Department from "./components/OtherInfo/Department/department";
import PositionMeeting from "./components/OtherInfo/Position_Meeting/position_meeting";

import Meeting from "./components/Meeting";
import MeetingCreate from "./components/Meeting/Create";
import MeetingEdit from "./components/Meeting/Edit";
import MeetingView from "./components/Meeting/View";
import MeetingUserView from "./components/Meeting/UserView/MeetingView";
import MeetingReportView from "./components/Meeting/Report/MeetingReportView";
import MeetingReportConfirm from "./components/Meeting/Report/MeetingReportConfirm";
import MeetingAgenda from "./components/Agenda";

import User from "./components/User/user/user";
import CreateUser from "./components/User/user/createUser";
import EditUser from "./components/User/user/editUser";

import UserRole from "./components/User/userRole/userRole";
import CreateRole from "./components/User/userRole/createRole";
import EditRole from "./components/User/userRole/editRole";

import GroupName from "./components/OtherInfo/GroupName";
import GroupDetail from "./components/OtherInfo/GroupItem";

import 'antd/dist/antd.css';
import "./assets/styles/react-bootstrap-table.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/styles/shard-dashboards.1.1.0.css";
import "./assets/styles/styles.scss";

import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";

import { setApp } from "./actions/app.action";
import { connect } from "react-redux";

const isLoggedIn = (role) => {
  if (localStorage.getItem("token")) {
    return true;
  } else return false;
};

function ProtectedRoute({ component: Component, ...rest }) {
  //Check if token exist
  const token = localStorage.getItem("token");

  return (
    <Route
      {...rest}
      render={(props) =>
        token ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
}

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menuVisible: true,
      userDetail: "",
    };

    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    this.props.setApp(this);
  }

  componentWillMount() {
    Store.addChangeListener(this.onChange);
  }

  componentWillUnmount() {
    Store.removeChangeListener(this.onChange);
  }

  onChange() {
    this.setState({
      menuVisible: Store.getMenuState(),
    });
  }

  render() {
    const classes = classNames(!this.state.menuVisible && "sidebar-hidden");

    return (
      <Router>
        <div className={classes}>
          <Switch>
            <Route path="/" exact={true} component={Login} />
            <Route path="/login" component={Login} />
            <Route exact path="/oAuthCallback" component={OAuthCallback} />
            <Route exact path="/meeting/view/:id" component={MeetingView} />
            <Route exact path="/meeting/user/view/" component={MeetingUserView} />
            <Route exact path="/meeting/report/:id" component={MeetingReportView} />
            <Route exact path="/meeting/report/confirm/:id" component={MeetingReportConfirm} />
            <Container fluid>
              <Row>
                <MainSidebar />
                <Col
                  className="main-content p-0"
                  lg={{ size: 10, offset: 2 }}
                  md={{ size: 9, offset: 3 }}
                  sm="12"
                  tag="main"
                >
                  <MainNavbar />
                  <ProtectedRoute exact path="/meeting" component={Meeting} />
                  <ProtectedRoute exact path="/building" component={Building} />
                  <ProtectedRoute exact path="/location" component={Location} />
                  <ProtectedRoute exact path="/room" component={Room} />
                  <ProtectedRoute exact path="/title" component={Title} />
                  <ProtectedRoute exact path="/position" component={Position} />
                  <ProtectedRoute exact path="/department" component={Department} />
                  <ProtectedRoute exact path="/position_meeting" component={PositionMeeting} />
                  
                  <ProtectedRoute exact path="/meeting/create" component={MeetingCreate} />
                  <ProtectedRoute exact path="/meeting/edit/:id" component={MeetingEdit} />
                  <ProtectedRoute exact path="/agenda" component={MeetingAgenda} />
                  
                  <ProtectedRoute exact path="/user" component={User} />
                  <ProtectedRoute exact path="/createUser" component={CreateUser} />
                  <ProtectedRoute exact path="/editUser/:id" component={EditUser} />

                  <ProtectedRoute path="/role" component={UserRole} />
                  <ProtectedRoute path="/createRole" component={CreateRole} />
                  <ProtectedRoute path="/editRole/:id" component={EditRole}  />

                  <ProtectedRoute path="/group_name" component={GroupName} />
                  <ProtectedRoute exact path="/group/detail/:id" component={GroupDetail} />
                  
                </Col>
              </Row>
            </Container>
          </Switch>
        </div>
      </Router>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
  setApp,
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
